<template>
	<div id="visualizarIntimacoes">		
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="4">
				<a-row>
					<span class="tr-label">Filtrar data por:</span>
				</a-row>
				<a-row>
					<a-select 
						default-value="0" 
						:value="tipoData" 
						@change="handleTipoData" 
						:disabled="loading" 
						style="width: 80%">
							<a-select-option value="0">Envio Kurier</a-select-option>							
							<a-select-option value="1">Evento da Intimação</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span class="tr-label">Inicial:</span>
				</a-row>
				<a-row>
					<a-date-picker
						:defaultValue="moment(new Date(), 'YYYY-MM-DD')"
						@change="onChangeDataIncial"
						placeholder="Data Incial"
						style="width: 80%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span class="tr-label">Final:</span>
				</a-row>
				<a-row>
					<a-date-picker
						:defaultValue="moment(new Date(), 'YYYY-MM-DD')"
						@change="onChangeDataFinal"
						placeholder="Data Final"
						style="width: 80%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span>UF:</span>
				</a-row>
				<a-select
					style="width: 80%;"
					@change="onChangeUf"
					:value="valueUF"
					:disabled="loading"
					:allowClear="valueUF!='Todos'"
					>
					<a-select-option v-for="uf in ufs" :key="uf.key">
						{{uf.valor}}
					</a-select-option>
				</a-select>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>NPU:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 90%;"
						v-model="valueNPU"						
						@change="onChangeNPU"						
						:disabled="loading"						
						:allowClear="valueNPU!=null"
						v-mask="'#######-##.####.#.##.####'"
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="2">
				<a-row>
					<span>Status:</span>
				</a-row>
				<a-select
					style="width: 100%;"
					@change="onChangeStatus"
					:value="valueStatus"
					:disabled="loading"
					:allowClear="valueStatus!='Todos'"
					>
					<a-select-option value="Todos">Todos</a-select-option>
					<a-select-option value="0">Não Lida</a-select-option>
					<a-select-option value="1">Lida</a-select-option>
				</a-select>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"
					@click.stop.prevent="carregarIntimacoes()"
					:disabled="loading"
				>
				Pesquisar</a-button>
			</a-col>			
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-layout id="dp-trigger">
				<a-layout-sider :trigger="null" collapsible v-model="collapsed" :style="styleCollapsed">
					<a-row style="height: calc(100vh - 245px); overflow-y: none; overflow-x: auto; min-height: 100px;">
						<a-table					
							:rowSelection="rowSelection"
							:columns="columns"
							:rowKey="record => record.idIntimacao"
							:dataSource="data"
							:loading="{spinning:loading, tip:'Carregando...'}"
							:pagination="false"							
							v-if="collapsed"
							size="small"
							:scroll="{ y: 'calc(100vh - 285px)' }"
							:customRow="(record) => {
								return {		
									style: {										
										'border-left': record.idIntimacao == idIntimacaoSelect ? '2px solid #213596' : '2px solid #e8e8e8',
										'font-weight': record.statusLida == false ? 'bolder' : 'unset',
										'color': record.statusLida == false ? '#213596' : 'unset',
										'background': record.idIntimacao == idIntimacaoSelect ? '#5287c761' : '#fff'
									},
									on: {
										click: (event) => {this.onClickRow(record)},
									},
								};
							}"
						>
							<template slot="customTitleIntimacao">Intimação (Qtd: {{data.length}})
								<a-tooltip>
									<template slot="title">Imprimir</template>
									<a-button										
										type="primary"
										ghost
										icon="printer"
										@click.stop.prevent="imprimirSelects"
										:style="{'z-index': '1', 'position': 'absolute', 'right': '70px', 'top': '0px', 'padding': '0px', 'font-size': '27px', 'border': 'transparent', 
												'color': (rowSelection.selectedRowKeys.length <= 0) ? '#959da6': '', 
												'cursor': (rowSelection.selectedRowKeys.length <= 0) ? 'not-allowed' : ''}"
									/>									
								</a-tooltip>								
								<a-tooltip>
									<template slot="title">Exportar Excel</template>
									<a-button
										type="primary"
										ghost
										icon="file-excel"
										@click.stop.prevent="exportarExcel"
										:style="{'z-index': '1', 'position': 'absolute', 'right': '15px', 'top': '1px', 'padding': '0px', 'font-size': '26px', 'border': 'transparent',
												'color': (rowSelection.selectedRowKeys.length <= 0) ? '#959da6': '', 
												'cursor': (rowSelection.selectedRowKeys.length <= 0) ? 'not-allowed' : ''}"
									/>									
								</a-tooltip>								
							</template>
							<template
								slot="intimacao"
								slot-scope="intimacao, record"								
							>
								<div style="font-size: 11px;">
									<table>
										<tbody>
											<tr>
												<td style="width: 250px;">
													<div style="font-size: 13px; margin: -5px 0px 5px 0px;"><b>NPU:</b>&nbsp;{{record.numeroProcesso.trim()}}</div>
												</td>
												<td>
													<div style="margin: -5px 0px 5px 0px;"><b>Data Evento:</b>&nbsp;{{formatarDataLocal(record.dataDisponibilizacao, true, 'DD/MM/YYYY')}}</div>
												</td>
											</tr>
											<tr>
												<td style="width: 250px;">
													<div style="margin: 0px 0px 5px 0px;"><b>Início Prazo:</b>&nbsp;{{formatarDataLocal(record.inicioPrazo, false)}}</div>
												</td>
												<td>
													<div style="margin: 0px 0px 5px 0px;"><b>UF:</b>&nbsp;{{record.uf.length == 2 ? record.uf : record.uf.substring(0, 2)}}</div>
												</td>
											</tr>
											<tr>
												<td style="width: 250px;">
													<b>Final Prazo:</b>&nbsp;{{formatarDataLocal(record.finalPrazo, false)}}
												</td>
												<td>
													<b>Justiça:</b>&nbsp;{{record.esfera}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</template>
						</a-table>						
					</a-row>
				</a-layout-sider>
				<a-layout style="height: calc(100vh - 245px); overflow: hidden;">
					<a-layout-content>
						<a-tooltip>
							<template slot="title">Imprimir dados</template>
							<div
								style="z-index:1; position:absolute; right: 70px; padding: 8px; cursor: pointer;"            
							>
								<a-icon
									type="printer"
									@click="clickImprimir"
									:style="{'color': (textoConteudo == '') ? '#959da6' : '#1d375c', 'font-size': '25px', 'cursor': (textoConteudo == '') ? 'no-drop': 'pointer'}"
									:disabled="loading"
								/>
							</div>
						</a-tooltip>
						<a-tooltip>
							<template slot="title">{{collapsed ? 'Expandir' : 'Retrair'}}</template>
							<div
								style="z-index:1; position:absolute; right: 0px; padding: 8px; cursor: pointer;"            
							>
								<a-icon
									:type="!collapsed ? 'menu-unfold' : 'menu-fold'"
									@click="clickCollapsed"
									style="color:black; font-size: 25px;"
									:disabled="loading"
								/>
							</div>
						</a-tooltip>
						<a-tabs>
							<a-tab-pane key="1">
								<span slot="tab" style="color: #1d375c;">
									<a-icon type="file"/>Dados
								</span>
								<iframe
									ref="htmlIframe"
									sandbox="allow-downloads"
									class="conteudo-html-frame"
									style="width:100%; border: 0px;"									
								></iframe>
							</a-tab-pane>
						</a-tabs>
					</a-layout-content>
				</a-layout>
			</a-layout>
		</a-row>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import {mask} from 'vue-the-mask';
import Helpers from "@/util/Helpers";
import html2pdf from 'html2pdf.js';

const columns = [
	{
		//title: 'Intimação',
		//width: 300,
		slots: { title: 'customTitleIntimacao' },
		scopedSlots: { customRender: "intimacao" }		
	},
];

function setHeaderFooter(docPDF, headerImage64, footerImage64) {
	for (var i = 1; i <= docPDF.internal.getNumberOfPages(); i++) {
		docPDF.setPage(i);
		//Header
		docPDF.addImage(headerImage64, 'JPEG', -6, -3, 200, 0);
		// //Footer
		docPDF.addImage(footerImage64, 'JPEG', -6, 281, 200, 0);
		docPDF.setFont("verdana");
		docPDF.setFontSize(9);
		docPDF.text("Página "+ i +" de " + docPDF.internal.getNumberOfPages(), 200, 287, {align: 'right'});	
	}	
};

export default {
	directives: {mask},	
	name: "visualizarIntimacoes",
	data() {
		return {
			idTela: 7,
			moment,
			data: [],
			loading: false,
			columns,
			dateFormat: "DD/MM/YYYY",
			idUsuarioPortal: 0,
			idPerfilPortal: 0,
			ufs:[],
			valueUF: 'Todos',			
			collapsed: false,
			styleCollapsed: {},
			//intimacoesSelect: null,			
			rowSelection: {
				type:'checkbox',
				onChange: (selectedRowKeys, selectedRows) => {					
					this.rowSelection.selectedRowKeys = selectedRowKeys;					
					//this.intimacoesSelect = selectedRows.length == 0 ? null : selectedRows;
				},
				selectedRowKeys: [],
			},
			filter:{
				idUsuario: 0,
				//dataInicial: moment(new Date(), 'YYYY-MM-DD').subtract(7, 'days'),
				dataInicial: moment(new Date(), 'YYYY-MM-DD'),
				dataFinal: moment(new Date(), 'YYYY-MM-DD'),
				uf: null,
				NPU: null,
				statusLida: '0',
				tipoFiltroData: '0'
			},
			idIntimacaoSelect: 0,
			valueNPU: null,
			valueStatus: '0',
			textoConteudo: '',
			tipoData: '0'
		};
	},
	mounted() {
		this.idUsuarioPortal = this.$store.state.auth.idUser;
		this.idPerfilPortal = this.$store.state.auth.idPerfilPortal;
		this.ufs = [{key:'Todos', valor:'Todos'}, {key:'BR', valor:'BR'}];
		this.ufs = this.ufs.concat(this.$store.state.global.ufs.map(h => {
							return {...h}
						}));
		this.clickCollapsed();
		this.carregarIntimacoes();
	},
	methods: {
		carregarIntimacoes() {
			if (!this.validarFiltro())
				return;
			this.filter.idUsuario = this.idUsuarioPortal;
			this.filter.tipoFiltroData = this.tipoData;			
			this.loading = true;			
			IntimacaoWebApi.recuperarIntimacoesExibicao(this.filter)
				.then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Visualizar Intimações", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Visualizar Intimações", res.data.result);
					} else {
						this.data = res.data.result;
						this.idIntimacaoSelect = 0;
						this.textoConteudo = '';
						this.$refs.htmlIframe.src = this.textoConteudo;
						this.rowSelection.selectedRowKeys = [];
						this.cacheData = this.data.map(item => ({ ...item }));
					}				
				})
				.catch(res => {
					this.loading = false;					
					showNotificationError(this, "Visualizar Intimações", "Erro ao tentar carregar intimações.");
				});
		},
		validarFiltro() {			
			if (this.filter.dataInicial == null) {
				showNotificationError(this, "Visualizar Intimações", "Data Inicial é obrigatória.");
				return false;
			} else if (this.filter.dataFinal == null) {
				showNotificationError(this, "Visualizar Intimações", "Data Final é obrigatória.");
				return false;
			} 
			else {
				var diff = moment(this.filter.dataFinal, "DD/MM/YYYY").diff(moment(this.filter.dataInicial, "DD/MM/YYYY"));
				if (moment.duration(diff)._data.days < 0)
				{
					showNotificationError(this, "Visualizar Intimações", "Data Final não pode ser menor do que a Data Inicial.");
					return false;
				}
				if (moment.duration(diff)._data.months >= 1 || moment.duration(diff)._data.years >= 1)
				{
					showNotificationError(this, "Visualizar Intimações", "Período não pode ser maior do que 30 dias.");
					return false;
				}
			}			

			return true;
		},
		onClickRow(record) {
			this.idIntimacaoSelect = record.idIntimacao;			
			this.textoConteudo = this.montarCabecalho(record) + this.montarConteudo(record) + this.montarRodape(record);
			this.$refs.htmlIframe.src = "data:text/html;charset=iso-8859-15," + escape(this.textoConteudo);
			if (!record.statusLida)
			{
				this.loading = true;
				IntimacaoWebApi.atualizarStatusLida(this.idIntimacaoSelect, this.idUsuarioPortal)
					.then(res => {
						this.loading = false;
						if (res.data.statusCode == 200) {
							
							const newData = [...this.data];
							const newCacheData = [...this.cacheData];
							const target = newData.filter(item => this.idIntimacaoSelect === item.idIntimacao)[0];
							const targetCache = newCacheData.filter(item => this.idIntimacaoSelect === item.idIntimacao)[0];
							if (target && targetCache) {
								target.statusLida = true;
								delete target.editable;
								this.data = newData;
								Object.assign(targetCache, target);
								this.cacheData = newCacheData;
							}						
						} else {
							showNotificationError(this, "Visualizar Intimações", res.data.errorMessage);
						}				
					})
					.catch(res => {
						this.loading = false;
						showNotificationError(this, "Visualizar Intimações", "Erro ao tentar atualizar intimação.");
					});
			}
		},
		onChangeDataIncial(date, dateString) {					
			this.filter.dataInicial = dateString == '' ? null : date;
			this.data = [];
			this.textoConteudo = '';
			this.$refs.htmlIframe.src = this.textoConteudo;
		},
		onChangeDataFinal(date, dateString) {
			this.filter.dataFinal = dateString == '' ? null : date;
			this.data = [];
			this.textoConteudo = '';
			this.$refs.htmlIframe.src = this.textoConteudo;
		},
		onChangeUf(value) {			
			this.valueUF = value == undefined ? 'Todos' : value;
			this.filter.uf = this.valueUF == 'Todos' ? null : this.valueUF;
			this.data = [];
			this.textoConteudo = '';
			this.$refs.htmlIframe.src = this.textoConteudo;
		},
		onChangeNPU() {			
			this.filter.NPU = this.valueNPU;
			this.data = [];
			this.textoConteudo = '';
			this.$refs.htmlIframe.src = this.textoConteudo;
		},
		onChangeStatus(value) {
			this.valueStatus = value == undefined ? 'Todos' : value;
			this.filter.statusLida = this.valueStatus == 'Todos' ? null : this.valueStatus;
			this.data = [];
			this.textoConteudo = '';
			this.$refs.htmlIframe.src = this.textoConteudo;
		},
		handleTipoData(value) {
			this.data = [];
			this.tipoData = value;
		},
		clickCollapsed() {
			this.collapsed = !this.collapsed;
			if (this.collapsed) {
				this.styleCollapsed = {
					flex: "0 0 31%",
					maxWidth: "31%",
					minWidth: "31%",
					width: "31%",
					height: "calc(100vh - 245px)"
				};
			} else {
				this.styleCollapsed = {
					flex: "0 0 0%",
					maxWidth: "0%",
					minWidth: "0%",
					width: "0%",
					height: "calc(100vh - 245px)"
				};
			}
		},
		montarCabecalho(record) {			
			let cabecalho = `<html dir="ltr" lang="pt" class=""><head><meta charset="iso-8859-15"></head>
				<body style="font-family: verdana; color: #4d4d4d">
					<table">
						<tbody>
							<tr>
								<td style="width: 100%">
									<div style="font-size: 18px; margin-bottom: 7px;"><b>NPU:</b>&nbsp;${record.numeroProcesso.trim()}</div>
								</td>							
							</tr>
						</tbody>
					</table>
					<hr style="border: 1px solid;">
					<div style="font-size: 16px"><b>DADOS PAINEL</b></div><br>
					<table style="font-size: 14px;">
						<tbody>
							<tr>
								<td style="width: 50%;">
									<b>Status:</b>&nbsp;${record.tipoIntimacao}									
								</td>
								<td style="width: 50%;">
									<b>Retificada:</b>&nbsp;${record.retificada}									
								</td>
							</tr>
							<tr>
								<td>
									<b>Início Prazo:</b>&nbsp;${this.formatarDataLocal(record.inicioPrazo, false)}
								</td>
								<td>
									<b>Perfil Tribunal:</b>&nbsp;${record.perfil}
								</td>
							</tr>
							<tr>
								<td>
									<b>Final Prazo:</b>&nbsp;${this.formatarDataLocal(record.finalPrazo, false)}
								</td>
								<td>
									<b>Perfil Kurier:</b>&nbsp;${record.tipoPerfilTribunalInternal} - ${record.nomePerfilTribunalInternal}
								</td>								
							</tr>
						</tbody>
					</table>
					<br><hr style="border: 1px solid;">
					<div style="font-size: 16px"><b>DADOS PROCESSO</b></div><br>
					<table style="font-size: 14px;">
						<tbody>
							<tr>
								<td style="width: 50%;">
									<b>Tribunal:</b>&nbsp;${record.nomeJornal}
								</td>
								<td style="width: 50%;">
									<b>Classe:</b>&nbsp;${record.classe}
								</td>
							</tr>
							<tr>
								<td>
									<b>Justiça:</b>&nbsp;${record.esfera}
								</td>
								<td>
									<b>Assunto:</b>&nbsp;${record.assunto}
								</td>
							</tr>
							<tr>
								<td>
									<b>UF:</b>&nbsp;${record.uf.length == 2 ? record.uf : record.uf.substring(0, 2)}
								</td>
								<td>
									<b>Juiz:</b>&nbsp;${record.juiz}
								</td>
							</tr>
							<tr>
								<td>
									<b>Cidade:</b>&nbsp;${record.cidade}
								</td>
								<td>
									<b>Valor da Causa:</b>&nbsp;R$ ${this.formatStringLocal(record.valorCausa)}
								</td>
							</tr>
							<tr>
								<td>
									<b>Vara:</b>&nbsp;${record.vara}
								</td>
								<td>
									<b>Data Distribuição:</b>&nbsp;${this.formatarDataLocal(record.dataDistribuicao, false)}
								</td>
							</tr>
							<tr>
								<td>
									<div><b>Autor:</b>&nbsp;${record.parteAutora==null ? '' : record.parteAutora}</div>
								</td>
								<td>
									<b>Competência:</b>&nbsp;${record.competencia}
								</td>
							</tr>
							<tr>
								<td>
									<div><b>Réu:</b>&nbsp;${record.parteReu==null ? '' : record.parteReu}</div>
								</td>
								<td>
								</td>
							</tr>						
						</tbody>
					</table>
					<br><hr style="border: 1px solid;">
					<div style="font-size: 16px"><b>CONTEÚDO</b></div>
				</body>
			</html>`

			return cabecalho;
		},
		montarConteudo(record) {			
			let retorno = atob(record.conteudo64).substring(4, record.conteudo64.length);
			retorno = retorno.replace(/\<a\s*href(.|\n)*?\>/gm, '<a>');
			return retorno;
		},
		montarRodape(record) {
			let rodape = `<html dir="ltr" lang="pt" class=""><head><meta charset="iso-8859-15"></head>
				<body style="font-family: verdana; color: #4d4d4d">
					<br><br><hr style="border: 1px solid;">
					<div style="font-size: 16px"><b>INFORMAÇÕES ADICIONAIS</b></div><br>
					<table">
						<tbody>
							<tr>
								<td style="width: 100%">
									<b>Link Documento Anexo:</b>&nbsp;${this.montarLinks(record.linksAnexosKurier)}
								</td>
							</tr>
							<tr>
								<td style="width: 100%">
									<b>Data Captura Kurier:</b>&nbsp;${this.formatarDataLocal(record.dataDisponibilizacao, true, "DD/MM/YYYY")}
								</td>
							</tr>
							<tr>
								<td style="width: 100%">
									<div><b>Data Evento:</b>&nbsp;${record.dataEvento==null ? '' : this.formatarDataLocal(record.dataEvento, true, "DD/MM/YYYY")}</div>
								</td>
							</tr>							
						</tbody>
					</table>					
				</body>
			</html>`

			return rodape;
		},		
		montarLinks(linksAnexosKurier) {
			let retorno = "";
			let count = 1;
			if (linksAnexosKurier != null && linksAnexosKurier != "")
			{
				linksAnexosKurier.split('|').forEach(item => {
					retorno += `<a href=${item}>Anexo_${count}</a><br>`;
					count += 1;
				});
			}

			if (retorno != "")
				retorno = retorno.substring(0, retorno.length - 4)

			return retorno+'<br>';
		},
		imprimirSelects() {
			if (this.rowSelection.selectedRowKeys.length <= 0)
				return;

			this.loading = true;
			let conteudo = '';
			for (let i = 0; i < this.rowSelection.selectedRowKeys.length; i++) {
				let intimacao = this.data.find(a => a.idIntimacao == this.rowSelection.selectedRowKeys[i]);
				if (intimacao != undefined && intimacao != null)
				{
					conteudo += this.montarCabecalho(intimacao) + this.montarConteudo(intimacao) + this.montarRodape(intimacao);

					if (i != this.rowSelection.selectedRowKeys.length)
						conteudo += '<div class="html2pdf__page-break"></div>';
				}
			}

			var element = conteudo;
			var opt = {
				margin: [23, 9, 18, 9],
				filename: 'Intimações.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { scale: 2 },
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
			};

			// Internet Explorer 6-11
			var isIE = /*@cc_on!@*/false || !!document.documentMode;
			// Edge 20+
			var isEdge = !isIE && !!window.StyleMedia;
			var headerImage64 = this.$store.state.global.headerImage64;
			var footerImage64 = this.$store.state.global.footerImage64;
			const _this = this;
			html2pdf().set(opt).from(element).toPdf().get('pdf').then(function (pdf) {
				pdf.setProperties({
					title: 'Intimações',
				});

				setHeaderFooter(pdf, headerImage64, footerImage64);
				
				_this.loading = false;
				if (isIE || isEdge) {				
					pdf.save(opt.filename);
				} else {
					pdf.save(opt.filename);
					//window.open(pdf.output('bloburl'), '_blank');
				}
			});
		},
		async exportarExcel() {
			if (this.rowSelection.selectedRowKeys.length <= 0)
				return;
			this.loading = true;
			let relatorio = {
				listaId: this.rowSelection.selectedRowKeys,
				titulo: "Relatório Intimações.xlsx"
			};
			IntimacaoWebApi.exportarRelatorioIntimacoes(relatorio)
				.then(res => {
					this.loading = false;
					let data = res.data;					
					if (data !== null && typeof data !== "undefined") {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);						
						link.download = "Relatório_Intimações_" + new Date().toLocaleDateString() + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					} else {
						showNotificationError(this, "Visualizar Intimações", "Erro ao tentar gerar arquivo.");
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Visualizar Intimações", "Erro ao tentar gerar arquivo.");
				});
		},
		clickImprimir() {			
			if (this.textoConteudo == '')
				return;

			this.loading = true;
			var element = this.textoConteudo;
			var opt = {
				margin: [23, 9, 18, 9],
				filename: 'Dados_Intimação.pdf',
				image: { type: 'jpeg', quality: 0.98 },
				html2canvas: { scale: 2 },
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
			};

			// Internet Explorer 6-11
			var isIE = /*@cc_on!@*/false || !!document.documentMode;
			// Edge 20+
			var isEdge = !isIE && !!window.StyleMedia;
			var headerImage64 = this.$store.state.global.headerImage64;
			var footerImage64 = this.$store.state.global.footerImage64;
			const _this = this;
			html2pdf().set(opt).from(element).toPdf().get('pdf').then(function (pdf) {
				pdf.setProperties({
					title: 'Dados Intimação',
				});

				setHeaderFooter(pdf, headerImage64, footerImage64);
				
				_this.loading = false;
				if (isIE || isEdge) {				
					pdf.save(opt.filename);
				} else {
					pdf.save(opt.filename);
					//window.open(pdf.output('bloburl'), '_blank');
				}
			});
		},
		formatarDataLocal(data, isDateTime, format) {			
			if (!isDateTime)
			{
				var dateString = data;
				//var dateObj = new Date(dateString);
				//var momentObj = moment(dateObj);
				var momentObj = moment(data, "DD/MM/YYYY");
				if (momentObj._isValid)
					return momentObj.format('DD/MM/YYYY');
				else
					return data;
			} 
			else
			{			
				return Helpers.formatarData(data, isDateTime, format);
			}
		},
		formatStringLocal(value) {
			return Helpers.formatString(value);
		}
	},
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.tr-ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.conteudo-html-frame {
  height: calc(100vh - 290px);
  overflow-y: auto;
}
</style>
